module.exports = __webpack_public_path__ + "static/section1BG.393a9940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/section1BG.jpg
// module id = 226
// module chunks = 21571696733600 35783957827783